import * as React from 'react';
import Breadcrumbs, { BreadcrumbItem } from '../../../breadcrumbs/src/breadcrumbs';

interface Props {
  breadcrumbTrail?: BreadcrumbItem[];
}

const BillingDocBreadcrumbs = ({ breadcrumbTrail }: Props) => {
  return (
    <div data-testid="billing-doc-breadcrumbs">
      <Breadcrumbs items={breadcrumbTrail ?? []} />
    </div>
  );
};

export default BillingDocBreadcrumbs;
